import styled, {css} from 'styled-components'

import theme, {media} from '@/src/config/theme'

export const CatalogFiltersMobileBtn = styled.button`
  @media ${media.md} {
    display: none;
  }
`

export const Wrapper = styled.div``

export const ContainerCentered = styled.div`
  display: flex;
  justify-content: center;
`

export const Container = styled.div`
  width: 100%;
  max-width: ${theme.sizes.container}px;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: column;
  column-gap: 24px;
  
  @media ${media.md} {
    flex-direction: row;
  }
`

export const CatalogOptions = styled.div<{$mobileNoPadding?: boolean}>`
    ${props =>
      !props.$mobileNoPadding &&
      css`
        @media (max-width: ${theme.mediaSizes.md}px) {
          padding-top: 28px;
        }
      `}

`


export const DesktopPagination = styled.div`
`

export const PaginationOptions = styled.div`
  display: none;

  @media ${media.lg} {
    display: flex;
  }
`

export const MobilePagination = styled.div`
  padding-top: 28px;
`


export const Side = styled.div`
  
  @media ${media.md} {
    width: 300px;
  }
`

export const Content = styled.div`
  flex: 1;
`
